module.exports = __webpack_public_path__ + "img/103055.c6b5a045.png";